// extracted by mini-css-extract-plugin
export default {"logoBox":"Logo_logoBox__EOQRL","logo":"Logo_logo__mhlBn","tipsy":"Logo_tipsy__lS6Wo","static":"Logo_static__yuJJH"};